import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, CheckCircle, ArrowRight, Phone } from 'lucide-react';
import '../styles/SecteursPage.css';

const SecteursPage = () => {
  const navigate = useNavigate();

  const villes = [
    "Sherbrooke",
    "Magog",
    "Bromont",
    "Orford",
    "Eastman",
    "Austin",
    "Windsor",
    "Val-des-Sources",
    "Granby",
    "Cowansville",
    "Dunham",
    "Sutton",
    "Saint-Denis-de-Brompton",
    "Saint-François-Xavier-de-Brompton",
    "Ascot Corner",
    "Martinville",
    "Coaticook"
  ];

  const coverage = [
    "Service rapide partout en Estrie",
    "Déplacements inclus dans nos tarifs",
    "Disponibilité 7 jours sur 7",
    "Interventions d'urgence possibles"
  ];

  return (
    <div className="secteurs-page">
      {/* Hero Section */}
      <section className="secteurs-hero">
        <div className="container">
          <h1 className="display-large text-center mb-md">Secteurs desservis</h1>
          <p className="body-large text-center" style={{maxWidth: '700px', margin: '0 auto'}}>
            NVF est fier de servir l'ensemble de la région de l'Estrie avec des services professionnels de fertilisation naturelle et d'entretien paysager.
          </p>
        </div>
      </section>

      {/* Main Coverage Section */}
      <section className="coverage-section section">
        <div className="container">
          <div className="coverage-content-full">
            <div className="coverage-text">
              <div className="coverage-icon">
                <MapPin size={50} />
              </div>
              <h2 className="heading-1 mb-md">Partout en Estrie</h2>
              <p className="body-large mb-lg">
                Notre équipe se déplace dans toute la région de l'Estrie pour vous offrir des services professionnels d'entretien paysager. Que vous soyez à Sherbrooke, Magog, Bromont, Granby ou dans les environs, nous sommes là pour vous servir.
              </p>
              
              <div className="coverage-benefits">
                {coverage.map((item, index) => (
                  <div key={index} className="coverage-benefit">
                    <CheckCircle size={20} />
                    <span>{item}</span>
                  </div>
                ))}
              </div>

              <button className="btn-primary mt-lg" onClick={() => navigate('/contact')}>
                Demander une soumission
                <ArrowRight size={20} />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Cities List Section */}
      <section className="cities-section section bg-subtle">
        <div className="container">
          <h2 className="display-medium text-center mb-xl">Villes et municipalités</h2>
          <p className="body-large text-center mb-xl" style={{maxWidth: '700px', margin: '0 auto 48px'}}>
            Voici quelques-unes des principales villes et municipalités que nous desservons régulièrement :
          </p>
          
          <div className="cities-grid">
            {villes.map((ville, index) => (
              <div key={index} className="city-card nvf-card hover-lift">
                <MapPin className="city-icon" size={28} />
                <h3 className="heading-3">{ville}</h3>
              </div>
            ))}
          </div>

          <p className="text-center mt-xl body-medium" style={{color: 'var(--text-light)'}}>
            Vous ne voyez pas votre ville? <strong>Contactez-nous!</strong> Nous desservons l'ensemble de l'Estrie et ses environs.
          </p>
        </div>
      </section>

      {/* Service Areas Detail */}
      <section className="areas-detail-section section">
        <div className="container">
          <div className="areas-content">
            <h2 className="display-medium text-center mb-lg">Service complet, partout</h2>
            
            <div className="areas-grid">
              <div className="area-card">
                <div className="area-number">01</div>
                <h3 className="heading-3 mb-sm">Zone urbaine</h3>
                <p className="body-medium">
                  Services adaptés aux résidences en ville avec pelouses de petite à moyenne superficie. Intervention rapide et discrète.
                </p>
              </div>

              <div className="area-card">
                <div className="area-number">02</div>
                <h3 className="heading-3 mb-sm">Zone périurbaine</h3>
                <p className="body-medium">
                  Parfait pour les propriétés en banlieue avec terrains moyens à grands. Service personnalisé selon vos besoins.
                </p>
              </div>

              <div className="area-card">
                <div className="area-number">03</div>
                <h3 className="heading-3 mb-sm">Zone rurale</h3>
                <p className="body-medium">
                  Expertise pour les grandes propriétés et terrains ruraux nécessitant un entretien professionnel régulier.
                </p>
              </div>

              <div className="area-card">
                <div className="area-number">04</div>
                <h3 className="heading-3 mb-sm">Commercial</h3>
                <p className="body-medium">
                  Solutions pour entreprises, institutions et espaces commerciaux exigeant une image soignée en tout temps.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="secteurs-cta section">
        <div className="container">
          <div className="cta-box">
            <h2 className="display-medium text-center mb-md">
              Vous êtes en Estrie? Nous sommes là pour vous!
            </h2>
            <p className="body-large text-center mb-lg" style={{maxWidth: '600px', margin: '0 auto 32px', color: 'white'}}>
              Obtenez une soumission gratuite pour votre propriété. Nos services sont disponibles partout en Estrie.
            </p>
            <div className="cta-buttons">
              <button className="btn-primary btn-large" onClick={() => navigate('/contact')}>
                Demander une soumission
                <ArrowRight size={22} />
              </button>
              <a href="tel:4502101858" className="btn-outline-light btn-large">
                <Phone size={20} />
                450 210 1858
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SecteursPage;
